import React from 'react';

// Components
import BlockStyledEditor from '../../Framework/Components/Form/BlockStyledEditor';
import Form from '../../Framework/Components/Form/Form';
import TextInput from '../../Framework/Components/Form/TextInput';
import Toggle from '../../Framework/Components/Form/Toggle';
import Image from '../../Framework/Components/Image/Image';
import Grid, { GridLeft, GridRight } from '../../Framework/Layouts/Grid';
import EntityUrlText from '../Products/EntityUrlText';
import routes from '../../Routes/routes';
import TypedTagInput from '../../Framework/Components/Form/TypedTagInput';

const BrandForm = (props) => {
    return (
        <Form {...props}>
            <Grid>
                <GridLeft>
                    <EntityUrlText path={routes.brand} buttonText="Brand" />
                    <TextInput name="title" />
                    <TextInput name="url" />
                    <TextInput name="where_to_find" />
                    <BlockStyledEditor name="description" fullFeatureSet />
                </GridLeft>

                <GridRight>
                    <Toggle name="featured" />
                    <TypedTagInput name="tags" filterByType />
                    <Image name="image" limit={1} isDetachable />
                </GridRight>
            </Grid>
        </Form>
    );
};

export default BrandForm;
